"use client";

import React from "react";
import { Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const profiles = [{
  title: "Antreprenori",
  description: "\n"
}, {
  title: "Freelanceri",
  description: "Pentru cei care vor să înceapă de la zero"
}, {
  title: "Specialiști beauty",
  description: "\n"
}, {
  title: "Medici și clinici",
  description: "Pentru antreprenori mici care nu reușesc să scaleze"
}, {
  title: "Persoane care vor să își dezvolte afacerea și brandingul personal",
  description: "\n"
}];
export default function ProfilulParticipantului() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="profilul-participantului" className="dark bg-background text-foreground py-20 md:py-32 overflow-hidden" ref={sectionRef} data-animate={isSectionVisible || undefined}>
      <div className="container">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-sans text-center text-primary-500 mb-6 tracking-tight">
          Acest curs este potrivit pentru:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {profiles.map((profile, i) => <Card key={i} data-index={i} className="card border-white/10 hover:shadow-xl hover:shadow-primary-500/20 transition-all duration-300">
              <CardContent className="p-8 sm:p-10 flex flex-col gap-6">
                <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center shrink-0 shadow-xl shadow-primary-500/30">
                  <Check className="w-7 h-7 text-foreground" strokeWidth={3} />
                </div>
                <div className="space-y-3">
                  <h3 className="text-xl font-bold tracking-wide !text-[hsl(0,0%,100%)] sm:text-2xl">
                    {profile.title}
                  </h3>
                  
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}